import * as React from "react";
import { api, GetAllNetworks } from "../../../../components/helpers";
import { ClassCPage } from "../../../../components/pages/ClassCPage";
import Layout from "../../../../components/layouts/DatoDocsLayout";
import Head from "next/head";
import { APITurnstile } from "../../../../components/APITurnstile";

export async function getStaticPaths() {
    const classC = await api.get_all_classC();    
    const paths = classC.data.allClasscEndpoints.map((post) => `/docs/unified-api/class-c/${post.application.slug}`) || [];

    return {
        paths: paths,
        fallback: false
    };
}

export async function getStaticProps({ params }) {
    const allClassC = await api.get_all_classC();    
    const classC = allClassC.data.allClasscEndpoints.filter(c => c.application.slug === params.slug);
    const networks = await GetAllNetworks();
    

    return {
        props: {
            post: classC[0],
            networks,
            allClassC,
            params: params,
            component: "ClassC"
        },
    };
}

export default function ClassC({ post, allClassC, userKey, user, mobileMenuIsOpen, setMobileMenu, handleToast }) {
    return <><Head><link
        rel="canonical"
        href={`https://www.covalenthq.com/docs/unified-api/class-c/${post.application.slug}/`}
        key="canonical" /></Head><Layout user={user} mobileMenuIsOpen={mobileMenuIsOpen} setMobileMenu={setMobileMenu} handleToast={handleToast}><article>
        <ClassCPage userKey={userKey} classC={post} allClassC={allClassC} />
    </article>
    <APITurnstile/>
    </Layout></>;

}

